import React from 'react'
import { Input, InputProps, Typography } from 'antd'
import { FieldError } from 'react-hook-form'
import ErrorText from 'src/app/shared/components/common/error-text'
import './index.scss'

const CustomInput: React.FC<
  Omit<InputProps, 'value'> & {
    label?: string
    required?: boolean
    error?: FieldError
    value: any
    containerStyle?: React.CSSProperties
  }
> = (props) => {
  const { label, required, size = 'large', error, style, containerStyle, ...etc } = props

  return (
    <div
      className='custom-input'
      style={{
        flex: 1,
        ...containerStyle,
      }}
    >
      <Typography.Text
        style={{ textAlign: 'left', fontSize: '14px', fontWeight: 700 }}
        className={`${required ? 'required' : ''} custom-select-label`}
      >
        {label}
      </Typography.Text>
      <Input
        size={size}
        style={{
          marginBottom: error ? 4 : 0,
          marginTop: 4,
          ...style,
        }}
        status={!!error ? 'error' : ''}
        {...etc}
      />
      {error && <ErrorText>{error.message}</ErrorText>}
    </div>
  )
}

export default CustomInput
